/* This file is mainly for giving a scehma to responses that are sent by backend. */

class LevelUpDetails {
  constructor({ currentJobFunction, currentJobRole, jobCompetencies, isShowWelcome, accessible }) {
    this.currentJobFunction = currentJobFunction;
    this.currentJobRole = currentJobRole;
    this.jobCompetencies = jobCompetencies;
    this.isShowWelcome = isShowWelcome;
    this.accessible = accessible;
  }

  static fromJSON({ currentJobFunction, currentJobRole, jobCompetencies, isShowWelcome, accessible }) {
    return new LevelUpDetails({
      currentJobFunction: new JobFunction(currentJobFunction),
      currentJobRole: new JobRole(currentJobRole),
      jobCompetencies: Array.isArray(jobCompetencies) ? jobCompetencies.map((jC) => JobCompetency.fromJSON(jC)) : [],
      isShowWelcome,
      accessible,
    });
  }
}

class JobCompetency {
  constructor({ levelUpId, jobFunction, jobRole, isCurrentRole, competencies }) {
    this.levelUpId = levelUpId;
    this.jobFunction = jobFunction;
    this.jobRole = jobRole;
    this.isCurrentRole = isCurrentRole;
    this.competencies = competencies;
  }

  static fromJSON({ levelUpId, jobFunction, jobRole, isCurrentRole, competencies }) {
    return new JobCompetency({
      levelUpId,
      jobFunction: new JobFunction(jobFunction),
      jobRole: new JobRole(jobRole),
      isCurrentRole,
      competencies: Array.isArray(competencies)
        ? competencies.map((competency) => Competency.fromJSON(competency))
        : [],
    });
  }
}

class Competency {
  constructor({
    levelUpCompetencyId,
    competencyId,
    name,
    targetPeriodStart,
    subCompetencies,
    progress,
    competencyStatus,
    progressBar,
  }) {
    // currently not being used on ui anywhere.
    this.levelUpCompetencyId = levelUpCompetencyId;
    this.competencyId = competencyId;
    this.name = name;
    this.targetPeriodStart = targetPeriodStart;
    this.subCompetencies = subCompetencies;
    this.progress = progress;
    this.competencyStatus = competencyStatus;
    this.progressBar = progressBar;
  }

  static fromJSON({
    levelUpCompetencyId,
    competencyId,
    name,
    targetPeriodStart,
    subCompetencies,
    progress,
    competencyStatus,
    progressBar,
  }) {
    return new Competency({
      levelUpCompetencyId,
      competencyId,
      name,
      targetPeriodStart: targetPeriodStart ? LevelUpTargetDate.fromJSON(targetPeriodStart) : null,
      subCompetencies: Array.isArray(subCompetencies)
        ? subCompetencies.map((subcompetency) => SubCompetency.fromJSON(subcompetency))
        : [],
      progress,
      competencyStatus,
      progressBar,
    });
  }
}

class SubCompetency {
  constructor({ levelUpCompetencyId, subCompetencyId, name, targetPeriodStart }) {
    // currently not being used on ui anywhere.
    this.levelUpCompetencyId = levelUpCompetencyId;
    this.subCompetencyId = subCompetencyId;
    this.name = name;
    this.targetPeriodStart = targetPeriodStart;
  }

  static fromJSON({ levelUpCompetencyId, subCompetencyId, name, targetPeriodStart }) {
    return new Competency({
      levelUpCompetencyId,
      subCompetencyId,
      name,
      targetPeriodStart: targetPeriodStart ? LevelUpTargetDate.fromJSON(targetPeriodStart) : null,
    });
  }
}

class JobFunction {
  constructor({ name, uuid }) {
    this.name = name;
    this.uuid = uuid;
  }
}

class JobRole {
  constructor({ name, uuid }) {
    this.name = name;
    this.uuid = uuid;
  }
}

class LevelUpTargetDate {
  constructor({ periodStartDate, periodDuration, periodName }) {
    this.periodStartDate = periodStartDate;
    this.periodDuration = periodDuration;
    this.periodName = periodName;
  }

  static fromJSON({ periodStartDate, periodDuration, periodName }) {
    return new LevelUpTargetDate({
      periodStartDate,
      periodDuration,
      periodName,
    });
  }
}
class LevelUpProgressStatus {
  constructor({ colour, displayName, description, status, progress }) {
    this.colour = colour;
    this.displayName = displayName;
    this.description = description;
    this.progress = progress;
  }

  static fromJSON({ colour, displayName, description, status, progress }) {
    return new LevelUpProgressStatus({
      colour,
      displayName,
      description,
      progress,
    });
  }
}
class LevelUpCompetencyDetails {
  constructor({
    competencyDescription,
    competencyId,
    competencyName,
    jobFunction,
    jobRole,
    levelUpCompetencyId,
    levelUpId,
    progress,
    targetDate,
    progressBar,
    competencyStatus,
    activity,
    accessible,
    recommendations,
    showAddToAgenda,
  }) {
    this.competencyDescription = competencyDescription;
    this.competencyId = competencyId;
    this.competencyName = competencyName;
    this.jobFunction = jobFunction;
    this.jobRole = jobRole;
    this.levelUpCompetencyId = levelUpCompetencyId;
    this.levelUpId = levelUpId;
    this.progress = progress;
    this.targetDate = targetDate;
    this.progressBar = progressBar;
    this.competencyStatus = competencyStatus;
    this.activity = activity;
    this.accessible = accessible;
    this.recommendations = recommendations;
    this.showAddToAgenda = showAddToAgenda;
  }

  static fromJSON({
    competencyDescription,
    competencyId,
    name,
    jobFunction,
    jobRole,
    levelUpCompetencyId,
    levelUpId,
    progress,
    targetPeriodStart,
    progressBar,
    competencyStatus,
    activity,
    accessible,
    recommendations,
    showAddToAgenda,
  }) {
    return new LevelUpCompetencyDetails({
      competencyDescription,
      competencyId,
      competencyName: name,
      jobFunction: new JobFunction(jobFunction),
      jobRole: new JobRole(jobRole),
      levelUpCompetencyId,
      levelUpId,
      progress,
      targetDate: targetPeriodStart ? LevelUpTargetDate.fromJSON(targetPeriodStart) : null,
      progressBar,
      competencyStatus,
      activity,
      accessible,
      recommendations,
      showAddToAgenda,
    });
  }
}

class LevelUpRiskEstimationList {
  constructor({ displayName, risk }) {
    this.displayName = displayName;
    this.risk = risk;
  }

  static fromJSON({ displayName, risk }) {
    return new LevelUpRiskEstimationList({
      displayName,
      risk,
    });
  }
}

export const ApiResponse = {
  LevelUpDetails,
  LevelUpTargetDate,
  LevelUpProgressStatus,
  LevelUpCompetencyDetails,
  LevelUpRiskEstimationList,
};
